import { render, staticRenderFns } from "./CartItemTable.vue?vue&type=template&id=646fd67c&scoped=true&"
import script from "./CartItemTable.vue?vue&type=script&lang=js&"
export * from "./CartItemTable.vue?vue&type=script&lang=js&"
import style0 from "./CartItemTable.vue?vue&type=style&index=0&id=646fd67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646fd67c",
  null
  
)

export default component.exports